import React, { useState } from "react";
import $ from "jquery";
import axios from "axios"; 
import FormValidator from "../../../inc/FormValidator";
import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";
import Button from "../../inc/Button";
import Collapse from "../../inc/Collapse"; 
import FieldsRenderer from "../../Purchase Orders Internal/Edit PO/FieldsRenderer";
import Helper from "../../../inc/Helper";
import { Form } from "react-bootstrap";
import { getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import Popup from "../../Popup/Popup"; 
import { connect } from "react-redux";

let cancelTokenSource = axios.CancelToken.source();
const AppMasterFormsPopup = ({ setClosePopupViewModal, reloadParentGrid }) => { 
  const [popupFormData, setPopupFormData] = useState({});
 
  const [apiCallBtn, setApiCallBtn] = useState(false);

  let popupFormValidator;

  const validationConfigure = () => {
    let popupFieldConfig = [
      { name: "app_name", displayName: "App name", types: ["Required"] },
      { name: "app_description", displayName: "App description", types: ["Required"] },
      { name: "base_url", displayName: "Base URL", types: ["Required"] },
      { name: "login_payload", displayName: "Login payload", types: ["Required"] }
    ];

    if (!popupFormValidator) {
      popupFormValidator = new FormValidator(popupFieldConfig);
    }
  };

  validationConfigure();
 
  const fieldsArrayGeneral = [
    {
      className: "col-lg-4",
      label: "App name",
      inputType: "text",
      id: "app_name",
      required: true,
      name: "app_name",
    },
    {
      className: "col-lg-4",
      label: "App description",
      inputType: "text",
      required: true,
      id: "app_description",
      name: "app_description",
    },
    {
      className: "col-lg-4",
      label: "Base URL",
      inputType: "text",
      required: true,
      id: "base_url",
      name: "base_url",
    },
    {
      className: "col-lg-4",
      label: "Login payload",
      inputType: "textarea",
      id: "login_payload",
      name: "login_payload",
      required: true,
    },
    {
      className: "col-lg-4",
      label: "Status",
      inputType: "dropdown",
      options: Settings.enumStatus,
      id: "status",
      name: "status",
      required: true,
    },
  ];

  const onClosePopupClick = () => {
    $("html").removeClass("rs_popup_open");
    setClosePopupViewModal(false);
  };

  const executePOSTPopupDocumentAPI = async () => {
    try { 
      let api = Api;
      api.setUserToken();

      const res = await api
        .axios()
        .post(
          Settings.apiAppUrl + "/details/",
          {
            ...popupFormData,
            login_payload: JSON.parse(popupFormData.login_payload)
          },
          { cancelToken: cancelTokenSource.token }
        );
        
      if (res?.data?.success) {
        Helper.alert(res?.data?.message || 'App master created successfully', 'success'); 
        reloadParentGrid();
        onClosePopupClick(); 
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    } catch (error) { 
      getPopupMessageBasedOnStatus(error);
    }
  };

  const handleSubmit = () => {
    if (!popupFormValidator.isValid({ ...popupFormData })) {
      popupFormValidator.displayMessage();
      popupFormValidator.reset();
      return;
    }

    if (!popupFormData.status && popupFormData.status !== 0) {
      Helper.alert('Status field is required', 'error');
      return;
  };

    Helper.createDebouncedAPIFunction(
      [executePOSTPopupDocumentAPI],
      setApiCallBtn,
      cancelTokenSource
    )();
  };
  return (
    <Popup
      autoOpen={true}
      width="900px"
      onClose={onClosePopupClick}
    >
      {(
        <>
          <h5 className="create_rfq_modal__title">Create App Master</h5>

          <Collapse
            className="mt-4 mb-4"
            open={true}
            title={"General Information"}
          >
            <Form>
              <div className="container-fluid">
                <FieldsRenderer
                  updateState={setPopupFormData}
                  currentState={popupFormData}
                  fieldsArray={fieldsArrayGeneral}
                />
              </div>
            </Form>
          </Collapse>
        </>
      )}

      <div
        className="addDocumentNumber-body-buttons"
        style={{ justifyContent: "flex-end" }}
      >
        <Button
          isActive={false}
          title={"Cancel"}
          onClick={onClosePopupClick}
        />
        <Button
          isDisable={apiCallBtn}
          className="solid_btn"
          isActive={true}
          title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>} 
          onClick={handleSubmit}
        />
      </div>
    </Popup>
  );
};

const mapStateToProps = (state) => {
  return {
    auth:state.auth
  }
}
 
export default connect(mapStateToProps) (AppMasterFormsPopup);